import styled from 'styled-components';
import { colors } from 'global/colors';

export const ExperienceBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background: rgba(0, 184, 184, 0.5);
  height: 28px;
  width: 100%;
  margin-top: 25px;

  :before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: ${colors.green};
    animation: experience 1s ease;
    animation-fill-mode: forwards;
    width: 0;

    @keyframes experience {
      from {
        width: 0;
      }
      to {
        width: ${(props) => props.experience}%;
      }
    }
  }
`;

export const ExperienceText = styled.span`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  margin-left: 10px;
  align-items: center;
  color: ${colors.white};
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  user-select: none;
`;

export const XPLevelBarText = styled.div`
  z-index: 999;
  color: #ffffff;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  margin: ${(props) => (props.margin ? `${props.margin}` : '0')};
  user-select: none;
`;

export const LevelImage = styled.img`
  width: 85px;
  position: absolute;
  margin-left: 110px;
  margin-bottom: 25px;
`;
